import { render } from "./RingLoader.vue?vue&type=template&id=4d349d7e"
import script from "./RingLoader.vue?vue&type=script&lang=js"
export * from "./RingLoader.vue?vue&type=script&lang=js"

import "./RingLoader.vue?vue&type=style&index=0&id=4d349d7e&lang=scss&loader=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__